import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    bancoId: 0,
    banco: null,
    bancoNombre: null,
    tarjetaMarcaId: 0,
    tarjetaMarca: null,
    tarjetaMarcaNombre: null,
    numeroCuenta: '',
    rowVersion: null,
    
    tarjetaDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_TARJETA'(state, tarjetaId) {
        state.id = tarjetaId;
        state.bancoId = 0;
        state.banco = null;
        state.bancoNombre = null;
        state.tarjetaMarcaId = 0;
        state.tarjetaMarca = null;
        state.tarjetaMarcaNombre = null;
        state.numeroCuenta = '';
        state.rowVersion = null;
    },
    'SET_TARJETA'(state, tarjeta) {
        state.bancoId = (tarjeta.banco) ? tarjeta.banco.id : 0;
        state.banco = tarjeta.banco;
        state.bancoNombre = (tarjeta.banco) ? tarjeta.banco.nombre.trim() : null;
        state.tarjetaMarcaId = (tarjeta.tarjetaMarca) ? tarjeta.tarjetaMarca.id : 0;
        state.tarjetaMarca = tarjeta.tarjetaMarca;
        state.tarjetaMarcaNombre = (tarjeta.tarjetaMarca) ? tarjeta.tarjetaMarca.nombre.trim() : null;
        state.numeroCuenta = tarjeta.numeroCuenta.trim();
        state.rowVersion = tarjeta.rowVersion;
    },
    'SET_BANCO'(state, banco) {
        state.banco = banco;
        state.bancoId = banco ? banco.id : 0;
        state.bancoNombre = banco ? banco.nombre.trim() : null;
    },
    'SET_TARJETA_MARCA'(state, tarjetaMarca) {
        state.tarjetaMarca = tarjetaMarca;
        state.tarjetaMarcaId = tarjetaMarca ? tarjetaMarca.id : 0;
        state.tarjetaMarcaNombre = tarjetaMarca ? tarjetaMarca.nombre.trim() : null;
    },

    'INICIALIZAR_TARJETA_DATOS' (state) {
        state.tarjetaDatos = [];
    },
    'SET_TARJETA_DATOS' (state, params) {
        state.tarjetaDatos = params.tarjetaDatos;
    }
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, tarjetaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TARJETA', tarjetaId);
            
            let getDatos = false;

            if (tarjetaId) {
                if (tarjetaId != 0) {
                    getDatos = true;
                }
            }

            if (getDatos) {
                apiAxios.get('tarjetas/' + tarjetaId + '/abm' ) 
                    .then(res => {
                        commit('SET_TARJETA', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let tarjeta = {
                bancoId: parseInt(state.bancoId),
                tarjetaMarcaId: parseInt(state.tarjetaMarcaId),
                numeroCuenta: state.numeroCuenta.toUpperCase().trim()
            }

            let url = 'tarjetas';
            if (state.id != 0) {
                tarjeta.rowVersion = state.rowVersion;
                url += '/' + state.id;
            }

            apiAxios.post(url, tarjeta)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setBanco: ({commit}, banco) => {
        commit('SET_BANCO', banco);
    },
    setTarjetaMarca: ({commit}, tarjetaMarca) => {
        commit('SET_TARJETA_MARCA', tarjetaMarca);
    },

    getTarjetaDatos ( { commit }, tarjetaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TARJETA_DATOS');

            if (tarjetaId != 0) {
                apiAxios.get('tarjetas/' + tarjetaId ) 
                .then(res => {
                    let tarjetaDatos = [
                        { 'nombre': 'banco', 'campo': 'Banco', 'valor': res.data.banco, 'formato': '' },
                        { 'nombre': 'tarjetaMarca', 'campo': 'Marca', 'valor': res.data.tarjetaMarca, 'formato': '' },
                        { 'nombre': 'numeroCuenta', 'campo': 'Nro Cuenta', 'valor': res.data.numeroCuenta, 'formato': '' },
                    ];
                    
                    let params = {
                        tarjetaDatos 
                    }
                    commit('SET_TARJETA_DATOS', params);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
        }, error => {
            reject(error);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}